import React, { useCallback } from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { deselectAll } from '../../actions';
import ItemControlButtons from '../ItemControlButtons';
import CameraIcon from '@wix/da-ds/pkg/Icons/24x24/AddCoverImage';
import MoveToFolderIcon from '@wix/da-ds/pkg/Icons/24x24/MoveToFolder';
import CopyIcon from '@wix/da-ds/pkg/Icons/Copy';
import SettingsIcon from '@wix/da-ds/pkg/Icons/24x24/Settings';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import GallectionListMenu from '../GallectionListMenu';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import { getFolderIdsDisabledForDeviationCopy, canMakeDeviationPremium, getPremiumFolderIds } from '../../helpers';
import withGallections from '../../_hocs/withGallections';
import { useManageDeviations } from '../../_hocs/withManageDeviations';
import LabelAsMenu from '../LabelAsMenu/LabelAsMenu';
import itemControlButtonStyles from '../ItemControlButtons/ItemControlButtons.scss';
const enhance = compose(withCurrentGallection, withGallections, connectMediaStore(null, {
    deselectAll
}));
const GallectionDeviationControlButtons = ({ deviation, gallections, currentFolderId, className, currentGallection })=>{
    const { t } = useTranslation();
    const itemLabelKeys = {
        makeCover: 'mediapopup.itemMenu.makeCover',
        moveTo: 'mediapopup.itemMenu.moveTo',
        copyTo: 'mediapopup.itemMenu.copyTo',
        labelAs: 'mediapopup.itemMenu.labelAs',
        deleteFrom: 'mediapopup.itemMenu.deleteFrom'
    };
    const { isCopyToSupportedGlobally, isMoveToSupportedGlobally, isCopyToSupportedInThisFolder, isMoveToSupportedInThisFolder, isSettingCoverImageSupportedInThisFolder, isRemoveSupportedInThisFolder, isLabelAsSupportedInThisFolder, copyTo, moveTo, setDeviationAsCover, remove } = useManageDeviations([
        deviation
    ]);
    const showCopyTo = isCopyToSupportedGlobally;
    const showMoveTo = isMoveToSupportedGlobally;
    const showLabelAs = isLabelAsSupportedInThisFolder;
    const isCopyToDisabled = !isCopyToSupportedInThisFolder;
    const isMoveToDisabled = !isMoveToSupportedInThisFolder;
    const isRemoveDisabled = !isRemoveSupportedInThisFolder;
    const removeClickHandler = useCallback(()=>{
        yieldToMain(()=>{
            remove();
        });
    }, [
        remove
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ItemControlButtons, {
        className: className,
        moreMenuClassName: itemControlButtonStyles['item-control-menu'],
        menuItems: [
            {
                // safe zone
                items: [
                    (currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.type) !== 'stash' && {
                        label: t(itemLabelKeys.makeCover),
                        icon: /*#__PURE__*/ React.createElement(CameraIcon, {
                            size: IconSize.SMALL
                        }),
                        onClick: ()=>setDeviationAsCover(deviation),
                        disabled: !isSettingCoverImageSupportedInThisFolder
                    },
                    showMoveTo && {
                        label: t(itemLabelKeys.moveTo),
                        submenu: /*#__PURE__*/ React.createElement(GallectionListMenu, {
                            onSelect: moveTo,
                            disableFolderIds: !canMakeDeviationPremium(deviation) ? getPremiumFolderIds(gallections) : []
                        }),
                        disabled: isMoveToDisabled,
                        icon: /*#__PURE__*/ React.createElement(MoveToFolderIcon, {
                            size: IconSize.SMALL
                        })
                    },
                    showCopyTo && {
                        label: t(itemLabelKeys.copyTo),
                        submenu: /*#__PURE__*/ React.createElement(GallectionListMenu, {
                            onSelect: copyTo,
                            disableFolderIds: getFolderIdsDisabledForDeviationCopy(gallections, currentFolderId, deviation)
                        }),
                        disabled: isCopyToDisabled,
                        icon: /*#__PURE__*/ React.createElement(CopyIcon, {
                            size: IconSize.SMALL
                        })
                    },
                    showLabelAs && {
                        label: t(itemLabelKeys.labelAs),
                        icon: /*#__PURE__*/ React.createElement(SettingsIcon, {
                            size: IconSize.SMALL
                        }),
                        submenu: /*#__PURE__*/ React.createElement(LabelAsMenu, {
                            gallection: currentGallection,
                            deviationIds: [
                                deviation.deviationId
                            ]
                        })
                    }
                ]
            },
            {
                // danger zone
                items: [
                    {
                        value: 3,
                        label: t(itemLabelKeys.deleteFrom),
                        icon: /*#__PURE__*/ React.createElement(TrashcanIcon, {
                            size: IconSize.SMALL,
                            disableDefaultColors: true
                        }),
                        danger: true,
                        disabled: isRemoveDisabled,
                        onClick: removeClickHandler
                    }
                ]
            }
        ]
    }));
};
export default enhance(GallectionDeviationControlButtons);

//# sourceMappingURL=GallectionDeviationControlButtons.js.map